import TagDefault from './TagDefault';
import TagInformation from './TagInformation';
import TagSuccess from './TagSuccess';
import TagWarning from './TagWarning';
import TagDestructive from './TagDestructive';
import TagBeta from './TagBeta';

export { TagDefault, TagInformation, TagSuccess, TagWarning, TagDestructive, TagBeta };
